/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ManOfTheMatchUserVotes = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
